export default {
  animal: 'Animal | Animals',
  client: 'Client | Clients',
  company: 'Company',
  companyName: 'Company name',
  description: 'Description',
  email: 'Email',
  firstName: 'First name',
  fullName: 'First and last name',
  lastName: 'Last name',
  name: 'Name',
  degree: 'Degree',
  gender: 'Gender',
  male: 'Male',
  female: 'Female',
  nofilled: 'No filled',
  notification: 'Notification | Notifications',
  orgId: 'Company ID',
  password: 'Password',
  passwordConfirm: 'Confirm your password',
  phone: 'Mobile phone',
  searchPlaceholder: 'Search...',
  service: 'Service | Services',
  settings: 'Settings',
  time: 'Time',
  user: 'User',
  vatId: 'VAT ID',
  vatPayer: 'VAT payer',
  image: 'Image | Images',
  businessHours: 'Opening hours'
}



// WEBPACK FOOTER //
// ./src/i18n/en/globals.js